const WEIGHT_UNIT_TYPE = 1;

export const isWeightUnit = unit => Number(unit) === WEIGHT_UNIT_TYPE;

export const normalizeEstimatedStockInput = (value, unit) => {
  const normalized = String(value ?? '').replace(',', '.');
  const pattern = isWeightUnit(unit)
    ? /^-?\d*(?:\.\d{0,3})?$/
    : /^-?\d*$/;
  return pattern.test(normalized) ? normalized : null;
};

export const formatQuantityForUnit = (value, unit, fallback = '') => {
  if (value === null || value === undefined || value === '') return fallback;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return fallback;
  return numeric.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: isWeightUnit(unit) ? 3 : 0,
    useGrouping: false,
  });
};

export const isWholeOrderQuantityInput = value => /^\d*$/.test(String(value ?? ''));
